"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaConstructionMetadataResponseMetadataToJSON = exports.RosettaConstructionMetadataResponseMetadataFromJSONTyped = exports.RosettaConstructionMetadataResponseMetadataFromJSON = void 0;
const runtime_1 = require("../runtime");
function RosettaConstructionMetadataResponseMetadataFromJSON(json) {
    return RosettaConstructionMetadataResponseMetadataFromJSONTyped(json, false);
}
exports.RosettaConstructionMetadataResponseMetadataFromJSON = RosettaConstructionMetadataResponseMetadataFromJSON;
function RosettaConstructionMetadataResponseMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'account_sequence': !runtime_1.exists(json, 'account_sequence') ? undefined : json['account_sequence'],
        'recent_block_hash': !runtime_1.exists(json, 'recent_block_hash') ? undefined : json['recent_block_hash'],
    };
}
exports.RosettaConstructionMetadataResponseMetadataFromJSONTyped = RosettaConstructionMetadataResponseMetadataFromJSONTyped;
function RosettaConstructionMetadataResponseMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'account_sequence': value.account_sequence,
        'recent_block_hash': value.recent_block_hash,
    };
}
exports.RosettaConstructionMetadataResponseMetadataToJSON = RosettaConstructionMetadataResponseMetadataToJSON;
//# sourceMappingURL=RosettaConstructionMetadataResponseMetadata.js.map